export const iconFontAwesomeCampingSignsPost = (
	<i className="fa-solid fa-signs-post"></i>
);
